import { Draft, PayloadAction } from '@reduxjs/toolkit';
import EWorkerType from 'enums/workerTypes';
import IWorker from 'models/Worker';

import { IWorkerData } from '../../initialState';

type IEditWorkerSuccessAction = IWorker;

function editSuccess(
  draft: Draft<IWorkerData>,
  action: PayloadAction<IEditWorkerSuccessAction>,
) {
  draft.edit.config.isLoading = false;
  draft.getAll.list = draft.getAll.list.map(worker => {
    let workerType = '';

    switch (true) {
      case action.payload.accountant:
        workerType = EWorkerType.Accountant;
        break;

      case action.payload.technician:
        workerType = EWorkerType.Technician;
        break;

      default:
        workerType = EWorkerType.Admin;
        break;
    }
    if (worker.id === action.payload.id) {
      return { ...action.payload, type: workerType };
    }
    return worker;
  });
}

export default editSuccess;
